import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import '../../assets/css/components/coursesManagement/coursesManagementEditorModal.css';
import { useSelector } from 'react-redux';
import { RootState } from '../../app/store';
import LoaderModal from '../Loader/loaderModal';
import { Button, ButtonGroup, Card, Checkbox, DatePicker, DateRange, FilePicker, IconX, ListItem, Modal, RadioButton, RadioButtons, Select, SelectOption, TableData, TextArea, TextBox } from '@veneer/core';
import moment from 'moment';
import { ICourseManagementDto } from '../../models/dto/trainingApi/ICourseManagementDto';
import { RadioGroup } from '@mui/material';
import courseService from '../../services/trainingApi/course.service';
import { ICourseDataDto } from '../../models/dto/trainingApi/ICourseDataDtos';
import dataListService from '../../services/generalApi/dataList.service';
import roleService from '../../services/generalApi/role.service';
import { ICourseIn } from '../../models/input/trainingApi/ICourseIn';
import { ICourseUpdateIn } from '../../models/input/trainingApi/ICourseUpdateIn';


interface CourseEditorProps {
    onClose: () => void;
    isUpdating: boolean;
    courseToEdit?: ICourseManagementDto,
    coursesData: TableData[]
}

type SelectValue = number | string | boolean; //CHECK

interface IQuestionOption {
    option: string;
    correct: boolean;
}
interface IAssociationQuestion {
    option: string;
    answer: string;
}
interface IQuestions {
    type: number, // 4:single 1:multiple 2:true/false 3:associaiton
    question: string,
    hint: string,
    numberOptions?: SelectValue[],
    options?: IQuestionOption[],
    trueFalse?: string,
    associationQuestions?: IAssociationQuestion[]
}

const CourseManagementEditorModal: React.FC<CourseEditorProps> = ({ onClose, isUpdating, courseToEdit, coursesData }) => {
    const [t] = useTranslation("global");
    const languageId: any = useSelector((state: RootState) => state.languageId);

    //loadings
    const [loading, setLoading] = useState<boolean>(true);
    const [loadingImage, setLoadingImage] = useState(false);
    const [loadingMaterial, setLoadingMaterial] = useState(false);



    //disables
    const [disable1, setDisable1] = useState<boolean>(true);
    const [disable2, setDisable2] = useState<boolean>(true);
    const [disable3, setDisable3] = useState<boolean>(true);
    const [disable4, setDisable4] = useState<boolean>(true);
    const [disable5, setDisable5] = useState<boolean>(true);
    const [disabledCountries, setDisabledCountries] = useState<boolean>(true);


    //data
    const [clasifications, setClasifications] = useState<SelectOption[]>([]);
    const [cateogories, setCategories] = useState<SelectOption[]>([]);
    const [subcategories, setSubcategories] = useState<SelectOption[]>([]);
    const [prerequisites, setPrerequisites] = useState<SelectOption[]>([]);
    const [languages, setLanguages] = useState<SelectOption[]>([]);
    const [countries, setCountries] = useState<SelectOption[]>([]);
    const [roles, setRoles] = useState<SelectOption[]>([]);



    const [clasificationSelected, setClasificationSelected] = useState<SelectValue[]>([]);
    const [categorySelected, setCategorySelected] = useState<SelectValue[]>([]);
    const [subcategorySelected, setSubcategorySelected] = useState<SelectValue[]>([]);
    const [prerequisitesSelected, setPrerequisitesSelected] = useState<SelectValue[]>([]);
    const [languageSelected, setLanguageSelected] = useState<SelectValue[]>([]);
    const [countriesSelected, setCountriesSelected] = useState<SelectValue[]>([]);
    const [rolesSelected, setRolesSelected] = useState<SelectValue[]>([]);




    const [courseId, setCourseId] = useState<number>(NaN);
    const [title, setTitle] = useState<string>('');
    const [description, setDescription] = useState<string>('');
    const [materialTitle, setMaterialTitle] = useState<string>('');
    const [materialDescription, setMaterialDescription] = useState<string>('');

    const [fileName, setFileName] = useState<string>('');
    const [fileValue, setFileValue] = useState<File | null>(null);
    const [urlFile, setUrlFile] = useState<string | null>(null);

    const [materialFileName, setMaterialFileName] = useState<string>('');
    const [materialFileValue, setMaterialFileValue] = useState<File | null>(null);
    const [materialUrlFile, setMaterialUrlFile] = useState<string | null>(null);

    const [undefinedDates, setUndefinedDates] = useState<boolean>(false);

    const [startDate, setStartDate] = useState<string>("");
    const [endDate, setEndDate] = useState<string>("");


    const [modalCreateId, setModalCreateId] = useState<number>(1);

    const [questions, setQuestions] = useState<IQuestions[]>([]);

    //errors
    const [errorFilePicker, setErrorFilePicker] = useState(false);
    const [errorFilePickerMaterial, setErrorFilePickerMaterial] = useState(false);



    useEffect(() => {
        if (isUpdating) {
            if (courseToEdit) {
                chargeDataToUpdate(courseToEdit);
            } else {
                onClose();
            }
        } else {
            getData();
        }
    }, [])

    useEffect(() => {
        if (fileValue) {
            const formData = new FormData();
            formData.append("formFile", fileValue);
            try {
                setLoadingImage(true);
                courseService.postCourseImage(formData)
                    .then(r => {
                        if (r.path) {
                            setUrlFile(r.path);
                            setLoadingImage(false);
                        } else {
                            setLoadingImage(false);
                            setErrorFilePicker(true);
                        }
                    })
            } catch (error) {
                setLoadingImage(false);
                setErrorFilePicker(true);
            }
        }
    }, [fileValue])

    useEffect(() => {
        if (materialFileValue) {
            const formData = new FormData();
            formData.append("formFile", materialFileValue);
            try {
                setLoadingMaterial(true);
                courseService.postCourseFile(formData)
                    .then(r => {
                        if (r.path) {
                            setMaterialUrlFile(r.path);
                            setLoadingMaterial(false);
                        } else {
                            setLoadingMaterial(false);
                            setErrorFilePickerMaterial(true);
                        }
                    })
            } catch (error) {
                setLoadingMaterial(false);
                setErrorFilePickerMaterial(true);
            }
        }
    }, [materialFileValue])

    function cleanFileName(fileName: string): string {
        let cleanedName = fileName.replace(/\s+/g, '_');
        cleanedName = cleanedName.replace(/[^\w\-\.]/g, '');
        
        return cleanedName;
    }

    useEffect(() => {
        setCountriesSelected([])
        setCountries([])
        setDisabledCountries(true)
        if (languageSelected.length > 0) {
            if (isUpdating) {
                courseService.getCourseCountries(Number(languageSelected))
                .then((courseCountries: ICourseDataDto[]) => {
                    const courseCountriesTemp = fillData(courseCountries);
                    setCountries(courseCountriesTemp);
                    setDisabledCountries(false);

                    if(courseToEdit?.countriesID){
                        const countriesArray = courseToEdit.countriesID.split(',').map(id => Number(id.trim()));
                        const countriesTemp = new Set(courseCountriesTemp.map(item => item.value));
                        const validCountriesArray  = countriesArray.filter(id => countriesTemp.has(Number(id)));
                        setCountriesSelected(validCountriesArray);  
                    }
                })
                .catch((error: any) => {
                    console.error(error);
                    throw error;
                });

            } else {

                courseService.getCourseCountries(Number(languageSelected))
                    .then((courseCountries: ICourseDataDto[]) => {
                        const courseCountriesTemp = fillData(courseCountries);
                        setCountries(courseCountriesTemp);
                        setDisabledCountries(false);
                    })
                    .catch((error: any) => {
                        console.error(error);
                        throw error;
                    });

            }

        }
    }, [languageSelected])


    useEffect(() => {
        if (title && description && fileName && urlFile) {
            setDisable1(false);
        } else { setDisable1(true); }

    }, [title, description, fileName, urlFile])

    useEffect(() => {

        if (Number(clasificationSelected) === 3) {
            setCategorySelected([]);
            setSubcategorySelected([])
        } else if (Number(clasificationSelected) === 4) {
            setSubcategorySelected([])
        }

        if (clasificationSelected.length > 0) {
            setDisable2(false);
        } else { setDisable2(true); }

    }, [clasificationSelected, prerequisitesSelected])

    useEffect(() => {
        if (undefinedDates) {
            if (languageSelected.length > 0) {
                setDisable3(false);
            } else { setDisable3(true); }
        } else {
            if (languageSelected.length > 0 && startDate && endDate) {
                setDisable3(false);
            } else { setDisable3(true); }
        }
    }, [languageSelected, undefinedDates, startDate, endDate])

    
    useEffect(() => {
        if (materialTitle && materialDescription && materialFileName && materialUrlFile) {
            setDisable4(false);
        } else { setDisable4(true); }

    }, [materialTitle, materialDescription, materialFileName, materialUrlFile])


    useEffect(() => {
        if (questions.length === 0) {
            setDisable5(true);
        } else {
            const validate = validateQuestions(questions);
            if (validate) {
                setDisable5(false);
            } else {
                setDisable5(true);
            }
        }
    }, [questions])

    const validateQuestions = (questions: IQuestions[]): boolean => {
        for (const question of questions) {
            if (!question.question || question.question.length <= 3) {
                return false;
            }
            switch (question.type) {
                case 1: // Múltiple
                    if (!question.numberOptions || question.numberOptions.length === 0) {
                        return false;
                    }

                    const allOptionsValidMultiple = question.options?.every(option => option.option?.trim().length > 0);
                    if (!allOptionsValidMultiple) {
                        return false;
                    }

                    if (!question.options || !question.options.some(option => option.correct)) {
                        return false;
                    }
                    break;

                case 2: // Verdadero/Falso
                    if (question.trueFalse !== 'true' && question.trueFalse !== 'false') {
                        return false;
                    }
                    break;

                case 3: // Asociación
                    if (!question.associationQuestions || question.associationQuestions.length === 0) {
                        return false;
                    }
                    const hasValidAssociations = question.associationQuestions.every(association =>
                        association.option?.trim().length > 0 && association.answer?.trim().length > 0
                    );

                    if (!hasValidAssociations) {
                        return false;
                    }
                    break;

                case 4: // Única
                    if (!question.options || question.options.length === 0) {
                        return false;
                    }

                    const allOptionsValid = question.options?.every(option => option.option?.trim().length > 0);
                    if (!allOptionsValid) {
                        return false;
                    }

                    const correctOptions = question.options.filter(option => option.correct === true);

                    if (correctOptions.length !== 1) {
                        return false;
                    }
                    break;

                default:
                    return false;
            }
        }

        return true;
    };


    function formatDateToYearMonthDay(dateString: string) {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');

        return `${year}-${month}-${day}`;
    }

    const chargeDataToUpdate = async (courseData: ICourseManagementDto) => {
        try {
            await chargeCourseData(courseData);


            const [clasificationData, categoryData, subcategoryData, languageData, rolesData] = await Promise.all([
                courseService.getCourseClasification(languageId.value),
                courseService.getCourseCategories(languageId.value, 4),
                courseService.getCourseCategories(languageId.value, 2),
                courseService.getCourseLanguages(languageId.value),
                roleService.getRoleList(Number(languageId.value), 2)
            ]);

            const resultClasification = fillData(clasificationData);
            setClasifications(resultClasification);

            const resultCategories = fillData(categoryData);
            setCategories(resultCategories);

            const resultSubategories = fillData(subcategoryData);
            setSubcategories(resultSubategories);

            const preRequisites = fillDataPrerequisites(coursesData);
            setPrerequisites(preRequisites);

            const resultLanguages = fillData(languageData);
            setLanguages(resultLanguages);

            const resultRoles = fillData(rolesData);
            setRoles(resultRoles);

            courseData.clasificationID && setClasificationSelected([courseData.clasificationID]);
            courseData.categoryID && setCategorySelected([courseData.categoryID]);
            courseData.subCategoryID && setSubcategorySelected([courseData.subCategoryID]);
            courseData.languageID && setLanguageSelected([courseData.languageID]);

            if(courseData.prerequisitesID){
                const prerequisitesArray = courseData.prerequisitesID.split(',').map(id => Number(id.trim()));
                const prerequisitesTemp = new Set(preRequisites.map(item => item.value));
                const validPrerequisitesArray  = prerequisitesArray.filter(id => prerequisitesTemp.has(Number(id)));
                setPrerequisitesSelected(validPrerequisitesArray);  
            }

            if(courseData.rolesID){
                const rolesArray = courseData.rolesID.split(',').map(id => Number(id.trim()));
                const rolesTemp = new Set(resultRoles.map(item => item.value));
                const validRolesArray  = rolesArray.filter(id => rolesTemp.has(Number(id)));
                setRolesSelected(validRolesArray);  
            }


            const questionsTemp = fillDataCourseQuestions(courseData.courseEvaluation);
            setQuestions(questionsTemp);


        } catch (error) {
            console.error(error);
            setLoading(false);
            onClose();
        } finally {
            setLoading(false);
        }
    };
    const chargeCourseData = (courseData: ICourseManagementDto) => {
        return new Promise<void>((resolve, reject) => {
            try {
                setCourseId(courseData.courseID);
                setTitle(courseData.courseName);
                setDescription(courseData.courseDescription);
                if (courseData.undefined) {
                    setUndefinedDates(true);
                } else {
                    setUndefinedDates(false);
                    setStartDate(String(courseData.startDate))
                    setEndDate(String(courseData.endDate))
                }

                if(courseData.coverImage){
                    setFileName("image.jpg");
                    setUrlFile(courseData.coverImage);
                }

                const materialTemp: any =JSON.parse(courseData.courseMaterial);
                materialTemp[0].MaterialName && setMaterialTitle(materialTemp[0].MaterialName);
                materialTemp[0].MaterialDescription && setMaterialDescription(materialTemp[0].MaterialDescription);

                if(materialTemp[0].MaterialURL){
                    setMaterialFileName("file.zip");
                    setMaterialUrlFile(materialTemp[0].MaterialURL)
                } 
                resolve();

            } catch (error) {
                reject(error);
            }
        });
    };

    const fillDataCourseQuestions = (courseEvaluation: string): IQuestions[] => {
        const parsedEvaluation = JSON.parse(courseEvaluation);
        const questions = parsedEvaluation[0]?.Questions || [];
    
        const mappedQuestions: IQuestions[] = questions.map((question: any) => {
            if (question.Type === 4 || question.Type === 1) {
                // Preguntas de tipo Single (4) o Multiple (1)
                return {
                    type: question.Type,
                    question: question.QuestionText,
                    hint: question.Hint,
                    numberOptions: [question.Options?.length],
                    options: question.Options?.map((option: any) => ({
                        option: option.OptionText,
                        correct: !!option.IsCorrect 
                    }))
                };
            } else if (question.Type === 2) {
                // Pregunta de tipo True/False (2)
                const trueFalseValue = question.Options?.find((opt: any) => opt.IsCorrect === 1)?.OptionText === "True" ? "true" : "false";
                return {
                    type: question.Type,
                    question: question.QuestionText,
                    hint: question.Hint,
                    trueFalse: trueFalseValue
                };
            } else if (question.Type === 3) {
                // Pregunta de tipo Association (3)
                const optionsByColumn: { [key: number]: string[] } = {
                    1: [],
                    2: []
                };

                // Separar las opciones en columnas 1 y 2
                question.Options?.forEach((option: any) => {
                    if (option.Column === 1) {
                        optionsByColumn[1].push(option.OptionText);
                    } else if (option.Column === 2) {
                        optionsByColumn[2].push(option.OptionText);
                    }
                });
            
                // Agrupar las opciones en pares
                const associationQuestions = optionsByColumn[1].map((option, index) => ({
                    option: option,
                    answer: optionsByColumn[2][index] 
                }));
            
                return {
                    type: question.Type,
                    question: question.QuestionText,
                    hint: question.Hint,
                    numberOptions: [question.Options?.length],
                    associationQuestions: associationQuestions
                };
            }
    
            return null;
        }).filter((q: IQuestions | null) => q !== null); 
    
        return mappedQuestions;
    };
    



    const getData = async () => {
        try {
            setLoading(true);
            const clasificationList = await courseService.getCourseClasification(languageId.value);
            const resultClasification = fillData(clasificationList);
            setClasifications(resultClasification);

            const categoriesList = await courseService.getCourseCategories(languageId.value, 4);
            const resultCategories = fillData(categoriesList);
            setCategories(resultCategories);

            const subcategoriesList = await courseService.getCourseCategories(languageId.value, 2);
            const resultSubategories = fillData(subcategoriesList);
            setSubcategories(resultSubategories);

            const preRequisites = fillDataPrerequisites(coursesData);
            setPrerequisites(preRequisites);

            const languagesList = await courseService.getCourseLanguages(languageId.value);
            const resultLanguages = fillData(languagesList);
            setLanguages(resultLanguages);

            const rolesList = await roleService.getRoleList(Number(languageId.value), 2);
            const resultRoles = fillData(rolesList);
            setRoles(resultRoles);


        } catch (error) {
            console.error(error)
            setLoading(false);
            onClose()

        }
        finally {
            setLoading(false);

        }
    }

    const fillData = (data: ICourseDataDto[]) => {
        const dataTemp: SelectOption[] = [];
        for (let i = 0; i < data.length; i++) {
            const camp: ICourseDataDto = data[i];
            let selectData: SelectOption;
            selectData = {
                value: camp.fieldID,
                label: camp.fieldValue,
            };
            dataTemp.push(selectData);
        }
        return dataTemp;
    };

    const fillDataPrerequisites = (data: TableData[]) => {
        const dataTemp: SelectOption[] = [];
        for (let i = 0; i < data.length; i++) {
            const camp: TableData = data[i];
            let selectData: SelectOption;
            selectData = {
                value: camp.courseID,
                label: camp.courseName,
            };
            dataTemp.push(selectData);
        }
        return dataTemp;
    };


    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files) {
            const file = e.target.files[0];
            const maxSize = 5 * 1024 * 1024; // 5 MB
    
            if (file.size > maxSize) {
                setErrorFilePicker(true); 
                setFileValue(null); 
                setFileName(''); 
            } else {
                setErrorFilePicker(false);
                setFileValue(file);
                const nameTemp = cleanFileName(file.name);
                setFileName(nameTemp);
            }
        }
    };

    const onClearFilePicker = () => {
        setFileValue(null);
        setFileName("");

    };

    const handleFileChangeMaterial = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files) {
            setErrorFilePickerMaterial(false);
            setMaterialFileValue(e.target.files[0]);
            const nameTemp = cleanFileName(e.target.files[0].name);
            setMaterialFileName(nameTemp);
        }
    };

    const onClearFilePickerMaterial = () => {
        setMaterialFileValue(null);
        setMaterialFileName("");

    };
    const handleChangeDates = (date: DateRange) => {
        date.startDate !== null && setStartDate(String(date.startDate));
        date.endDate !== null && setEndDate(String(date.endDate));

    };

    const addQuestion = (type: number) => {
        const newQuestion: IQuestions = {
            question: "",
            hint: "",
            type: type,
        }
        const questionsTemp = [...questions];
        questionsTemp.push(newQuestion);
        setQuestions(questionsTemp);
    }

    const NumberOptions: SelectOption[] = [
        { value: 1, label: "1" },
        { value: 2, label: "2" },
        { value: 3, label: "3" },
        { value: 4, label: "4" },
        { value: 5, label: "5" },
        { value: 6, label: "6" },
        { value: 7, label: "7" },
        { value: 8, label: "8" },
        { value: 9, label: "9" },
        { value: 10, label: "10" },
    ]

    const handleChangeNumberOptions = (value: SelectValue, index: number) => {
        const questionsTemp = [...questions];

        if (!questionsTemp[index].options && Number(value) > 0) {
            questionsTemp[index].options = new Array(Number(value)).fill(null).map(() => ({ option: '', correct: false }));
        }
        else if (questionsTemp[index].options!.length < Number(value)) {
            const diff = Number(value) - questionsTemp[index].options!.length;
            questionsTemp[index].options = questionsTemp[index].options!.concat(
                new Array(diff).fill(null).map(() => ({ option: '', correct: false }))
            );
        }
        else if (questionsTemp[index].options!.length > Number(value)) {
            questionsTemp[index].options = questionsTemp[index].options!.slice(0, Number(value));
        }

        questionsTemp[index].numberOptions = [value];
        setQuestions(questionsTemp);
    };



    const handleChangeQuestion = (value: string, indexQuestion: number) => {
        const updatedQuestions = [...questions];
        updatedQuestions[indexQuestion].question = value;
        setQuestions(updatedQuestions);
    }

    const handleChangeHint = (value: string, indexQuestion: number) => {
        const updatedQuestions = [...questions];
        updatedQuestions[indexQuestion].hint = value;
        setQuestions(updatedQuestions);
    }

    const onClearNumberOptions = (index: number) => {
        const questionsTemp = [...questions];
        questionsTemp[index].numberOptions = [];
        questionsTemp[index].options = [];
        setQuestions(questionsTemp);
    }

    const handleChangeOption = (value: string, index: number, indexOption: number) => {
        const questionsTemp = [...questions];
        const question = questionsTemp[index];
        const options = question?.options;
        if (question && options && options[indexOption]) {
            options[indexOption].option = value;
            setQuestions(questionsTemp);
        }
    };


    const handleChangeRadioButton = (index: number, eventValue: string | number) => {
        const value = typeof eventValue === 'string' ? parseInt(eventValue, 10) : eventValue;
        const questionsTemp = [...questions];

        if (questionsTemp[index] && questionsTemp[index].options) {
            const optionsTemp = questionsTemp[index].options?.map((option, idx) => {
                return {
                    ...option,
                    correct: idx === value
                };
            });
            questionsTemp[index] = {
                ...questionsTemp[index],
                options: optionsTemp
            };

            setQuestions(questionsTemp);
        }
    };


    const handleChangeChecks = (index: number, indexOption: number) => {
        const questionsTemp = [...questions];
        const optionsTemp = [...questionsTemp[index].options!];
        optionsTemp[indexOption] = {
            ...optionsTemp[indexOption],
            correct: !optionsTemp[indexOption].correct,
        };
        questionsTemp[index].options = optionsTemp;
        setQuestions(questionsTemp);
    };




    const handleChangeRadioButtonTrueFalse = (index: number, eventValue: string) => {
        const questionsTemp = [...questions];
        questionsTemp[index].trueFalse = eventValue;
        setQuestions(questionsTemp);
    };


    const handleChangeNumberOptionsAssociation = (value: SelectValue, index: number) => {
        const questionsTemp = [...questions];

        if (!questionsTemp[index].associationQuestions && Number(value) > 0) {
            questionsTemp[index].associationQuestions = new Array(Number(value)).fill(null).map(() => ({
                option: '',
                answer: ''
            }));
        }
        else if (questionsTemp[index].associationQuestions!.length < Number(value)) {
            const diff = Number(value) - questionsTemp[index].associationQuestions!.length;
            questionsTemp[index].associationQuestions = questionsTemp[index].associationQuestions!.concat(
                new Array(diff).fill(null).map(() => ({ option: '', answer: '' }))
            );
        }
        else if (questionsTemp[index].associationQuestions!.length > Number(value)) {
            questionsTemp[index].associationQuestions = questionsTemp[index].associationQuestions!.slice(0, Number(value));
        }
        questionsTemp[index].numberOptions = [value];
        setQuestions(questionsTemp);
    };


    const onClearNumberOptionsAssociation = (index: number) => {
        const questionsTemp = [...questions];
        questionsTemp[index].numberOptions = [];
        questionsTemp[index].associationQuestions = [];
        setQuestions(questionsTemp);
    }

    const handleChangeOptionAssociation = (value: string, index: number, indexOption: number, type: string) => {
        if (type === "option") {
            const questionsTemp = [...questions];
            questionsTemp[index].associationQuestions![indexOption].option = value;
            setQuestions(questionsTemp);
        } else {
            const questionsTemp = [...questions];
            questionsTemp[index].associationQuestions![indexOption].answer = value;
            setQuestions(questionsTemp);
        }
    }

    const onDeleteQuestion = (index: number) => {
        const questionsTemp = [...questions];
        questionsTemp.splice(index, 1);
        setQuestions(questionsTemp);
    }

    const handleChangePrerequisites = (value: SelectValue) => {
        const prerequisitesCopy = [...prerequisitesSelected];
        const isOptionSelected = prerequisitesCopy.includes(value);
        if (isOptionSelected) {
            const index = prerequisitesCopy.indexOf(value);
            prerequisitesCopy.splice(index, 1);
        } else {
            prerequisitesCopy.push(value);
        }
        setPrerequisitesSelected(prerequisitesCopy)
    }

    const handleChangeCountries = (value: SelectValue) => {
        const countriesCopy = [...countriesSelected];
        const isOptionSelected = countriesCopy.includes(value);
        if (isOptionSelected) {
            const index = countriesCopy.indexOf(value);
            countriesCopy.splice(index, 1);
        } else {
            countriesCopy.push(value);
        }
        setCountriesSelected(countriesCopy)
    }

    const handleChangeRoles = (value: SelectValue) => {
        const rolescopy = [...rolesSelected];
        const isOptionSelected = rolescopy.includes(value);
        if (isOptionSelected) {
            const index = rolescopy.indexOf(value);
            rolescopy.splice(index, 1);
        } else {
            rolescopy.push(value);
        }
        setRolesSelected(rolescopy)
    }

    function getLabelQuestion(id: number): string | undefined {
        const QuestionTypes: { [key: number]: string } = {
            1: t("header.multipleAnswer"),
            2: t("header.trueFalse"),
            3: t("header.association"),
            4: t("header.singleAnswer"),
        };

        return QuestionTypes[id];
    }

    const onSubmit = () => {
        setLoading(true);
        const startDateTemp = startDate ? new Date(startDate).toISOString() : null;
        const endDateTemp = endDate ? new Date(endDate).toISOString() : null;

        let courseIn: ICourseIn = {
            name: title,
            description: description,
            clasificationID: Number(clasificationSelected),
            undefined: undefinedDates,
            startDate: startDateTemp,
            endDate: endDateTemp,
            coverImage: urlFile ? urlFile : '',
            categoryID: categorySelected.length > 0 ? Number(categorySelected) : undefined,
            subcategoryID: subcategorySelected.length > 0 ? Number(subcategorySelected) : undefined,
            material: JSON.stringify([
                {
                    "NAME": materialTitle,
                    "DESCRIPTION": materialDescription,
                    "ORDER": 1,
                    "URL": materialUrlFile,
                    "TYPE": 4
                },
            ]),
            evaluation: JSON.stringify({
                QUESTION: questions.map((question) => {
                    if (question.type === 4 || question.type === 1) {
                        // Single (4) o Multiple (1)
                        return {
                            TYPE: question.type,
                            TEXT: question.question,
                            HINT: question.hint,
                            OPTION: question.options?.map(option => ({
                                TEXT: option.option,
                                ANSWER: option.correct ? 1 : 0
                            }))
                        };
                    } else if (question.type === 2) {
                        // (2)
                        return {
                            TYPE: question.type,
                            TEXT: question.question,
                            HINT: question.hint,
                            OPTION: [
                                { TEXT: "True", ANSWER: question.trueFalse === "true" ? 1 : 0 },
                                { TEXT: "False", ANSWER: question.trueFalse === "false" ? 1 : 0 }
                            ]
                        };
                    } else if (question.type === 3) {
                        // (3)
                        return {
                            TYPE: question.type,
                            TEXT: question.question,
                            HINT: question.hint,
                            OPTION: question.associationQuestions?.map(association => ({
                                TEXT: association.option,
                                ANSWER: association.answer
                            }))
                        };
                    }
                    return null;
                }).filter(question => question !== null)
            }),
            userID: undefined,
            languageID: Number(languageSelected),
            roles: String(rolesSelected),
            countries: String(countriesSelected),
            prerequisites: String(prerequisitesSelected)
        }
        try {
            courseService.postCourse(courseIn)
                .then(r => {
                    setLoading(false);
                    onClose();
                })

        } catch (error) {
            console.error(error);
            setLoading(false);
            onClose();
        }

    }

    const handleChangeUndefinedDates = () => {
        if(!undefinedDates){
        setStartDate('');
        setEndDate('');
        }
        setUndefinedDates(!undefinedDates)
    }

    const onUpdate = () => {
        setLoading(true);
        const startDateTemp = startDate ? new Date(startDate).toISOString() : null;
        const endDateTemp = endDate ? new Date(endDate).toISOString() : null;

        let courseUpdateIn: ICourseUpdateIn = {
            courseID: courseId,
            name: title,
            description: description,
            clasificationID: Number(clasificationSelected),
            undefined: undefinedDates,
            startDate: startDateTemp,
            endDate: endDateTemp,
            coverImage: urlFile ? urlFile : '',
            categoryID: categorySelected.length > 0 ? Number(categorySelected) : undefined,
            subcategoryID: subcategorySelected.length > 0 ? Number(subcategorySelected) : undefined,
            material: JSON.stringify([
                {
                    "NAME": materialTitle,
                    "DESCRIPTION": materialDescription,
                    "ORDER": 1,
                    "URL": materialUrlFile,
                    "TYPE": 4
                },
            ]),
            evaluation: JSON.stringify({
                QUESTION: questions.map((question) => {
                    if (question.type === 4 || question.type === 1) {
                        // Single (4) o Multiple (1)
                        return {
                            TYPE: question.type,
                            TEXT: question.question,
                            HINT: question.hint,
                            OPTION: question.options?.map(option => ({
                                TEXT: option.option,
                                ANSWER: option.correct ? 1 : 0
                            }))
                        };
                    } else if (question.type === 2) {
                        // (2)
                        return {
                            TYPE: question.type,
                            TEXT: question.question,
                            HINT: question.hint,
                            OPTION: [
                                { TEXT: "True", ANSWER: question.trueFalse === "true" ? 1 : 0 },
                                { TEXT: "False", ANSWER: question.trueFalse === "false" ? 1 : 0 }
                            ]
                        };
                    } else if (question.type === 3) {
                        // (3)
                        return {
                            TYPE: question.type,
                            TEXT: question.question,
                            HINT: question.hint,
                            OPTION: question.associationQuestions?.map(association => ({
                                TEXT: association.option,
                                ANSWER: association.answer
                            }))
                        };
                    }
                    return null;
                }).filter(question => question !== null)
            }),
            userID: undefined,
            languageID: Number(languageSelected),
            roles: String(rolesSelected),
            countries: String(countriesSelected),
            prerequisites: String(prerequisitesSelected)
        }
        try {
            courseService.updateCourse(courseUpdateIn)
                .then(r => {
                    setLoading(false);
                    onClose();
                })

        } catch (error) {
            console.error(error);
            setLoading(false);
            onClose();
        }
    }

    return (
        <>
            {loading && <LoaderModal />}

            <div style={{ position: 'relative' }}>
                <Modal
                    align="center"
                    id="coursesManagementModalCreation"
                    className='coursesManagementModalCreation'
                    show={true}
                    closeButton
                    onClose={onClose}
                    footer={(() => {
                        switch (modalCreateId) {
                            case 1:
                                return (
                                    <ButtonGroup className="registerSaleButtongrouop">
                                        <Button onClick={onClose} appearance="secondary">{t("header.cancel")}</Button>
                                        <Button disabled={disable1} onClick={() => setModalCreateId(2)} >{t("header.next")}</Button>
                                    </ButtonGroup>
                                )
                            case 2:
                                return (
                                    <ButtonGroup className="registerSaleButtongrouop">
                                        <Button onClick={onClose} appearance="secondary">{t("header.cancel")}</Button>
                                        <Button onClick={() => setModalCreateId(1)} >{t("header.previous")}</Button>
                                        <Button disabled={disable2} onClick={() => setModalCreateId(3)} >{t("header.next")}</Button>
                                    </ButtonGroup>
                                )
                            case 3:
                                return (
                                    <ButtonGroup className="registerSaleButtongrouop">
                                        <Button onClick={onClose} appearance="secondary">{t("header.cancel")}</Button>
                                        <Button onClick={() => setModalCreateId(2)} >{t("header.previous")}</Button>
                                        <Button disabled={disable3} onClick={() => setModalCreateId(4)} >{t("header.next")}</Button>
                                    </ButtonGroup>
                                )
                            case 4:
                                return (
                                    <ButtonGroup className="registerSaleButtongrouop">
                                        <Button onClick={onClose} appearance="secondary">{t("header.cancel")}</Button>
                                        <Button onClick={() => setModalCreateId(3)} >{t("header.previous")}</Button>
                                        <Button disabled={disable4} onClick={() => setModalCreateId(5)} >{t("header.next")}</Button>
                                    </ButtonGroup>
                                )

                            case 5:
                                return (
                                    <ButtonGroup className="registerSaleButtongrouop">
                                        <Button onClick={onClose} appearance="secondary">{t("header.cancel")}</Button>
                                        <Button onClick={() => setModalCreateId(4)} >{t("header.previous")}</Button>
                                        <Button disabled={disable5} onClick={() => setModalCreateId(6)} >{t("header.next")}</Button>
                                    </ButtonGroup>
                                )

                            case 6:
                                return (
                                    <ButtonGroup className="registerSaleButtongrouop">
                                        <Button onClick={onClose} appearance="secondary">{t("header.cancel")}</Button>
                                        <Button onClick={() => setModalCreateId(5)} >{t("header.previous")}</Button>
                                        <Button disabled={false} onClick={isUpdating? onUpdate : onSubmit} >{isUpdating? t("header.updateCourse") : t("header.createCourse")}</Button>
                                    </ButtonGroup>
                                )
                                break;
                            default:
                                <p>{t("header.error")}</p>
                        }
                    })()}
                    title={isUpdating? t("header.updateCourse") : t("header.createCourse")}
                >
                    <div className="coursesManagementModalCreation">
                        {(() => {
                            if (modalCreateId === 1) {
                                return (<div>
                                    {loadingImage ? <LoaderModal /> : null}

                                    <TextBox
                                        className="coursesManagementModalCreationTextbox"
                                        label={t("header.title")}
                                        value={title}
                                        onChange={value => setTitle(value)}
                                        required
                                    />

                                    <TextArea
                                        className="coursesManagementModalCreationTextbox"
                                        label={t("header.description")}
                                        value={description}
                                        onChange={value => setDescription(value)}
                                        required
                                    />

                                    <FilePicker
                                        className="coursesManagementModalCreationFile"
                                        id="courseManagement-file-picker"
                                        label={t("header.uploadCourseCoverFile")}
                                        accept=".jpg,.jpeg,.png"
                                        onChange={handleFileChange}
                                        onClear={onClearFilePicker}
                                        value={fileName}
                                        error={errorFilePicker}
                                        helperText={t("header.errorFilePickerCourseCoverImage")}
                                        required
                                    />


                                </div>)

                            } else if (modalCreateId === 2) {
                                return (
                                    <div>

                                        <Select
                                            className="coursesManagementModalCreationSelect"
                                            label={t("header.clasification")}
                                            options={clasifications}
                                            value={clasificationSelected}
                                            placement="bottom-start"
                                            onChange={e => setClasificationSelected([e.value])}
                                            onClear={() => setClasificationSelected([])}
                                            required
                                        />
                                        {Number(clasificationSelected) !== 3 && <Select
                                            className="coursesManagementModalCreationSelect"
                                            label={t("header.category")}
                                            options={cateogories}
                                            value={categorySelected}
                                            placement="bottom-start"
                                            onChange={e => setCategorySelected([e.value])}
                                            onClear={() => setCategorySelected([])}
                                        />}
                                        {(Number(clasificationSelected) !== 3 && Number(clasificationSelected) !== 4) && <Select
                                            className="coursesManagementModalCreationSelect"
                                            label={t("header.subcategory")}
                                            options={subcategories}
                                            value={subcategorySelected}
                                            placement="bottom-start"
                                            onChange={e => setSubcategorySelected([e.value])}
                                            onClear={() => setSubcategorySelected([])}
                                        />}
                                        <Select
                                            className="coursesManagementModalCreationSelect"
                                            label={t("header.prerequisite")}
                                            options={prerequisites}
                                            value={prerequisitesSelected}
                                            placement="bottom-start"
                                            onChange={e => handleChangePrerequisites(e.value)}
                                            onClear={() => setPrerequisitesSelected([])}
                                            multiple
                                        />



                                    </div>
                                )
                            }
                            else if (modalCreateId === 3) {
                                return (
                                    <div>
                                        <p><strong>{t("header.audience")}</strong></p>
                                        <br />
                                        <Select
                                            className="coursesManagementModalCreationSelect"
                                            label={t("header.language")}
                                            options={languages}
                                            value={languageSelected}
                                            placement="bottom-start"
                                            onChange={e => setLanguageSelected([e.value])}
                                            onClear={() => setLanguageSelected([])}
                                            required
                                        />
                                        <Select
                                            className="coursesManagementModalCreationSelect"
                                            label={t("header.countries")}
                                            options={countries}
                                            value={countriesSelected}
                                            placement="bottom-start"
                                            onChange={e => handleChangeCountries(e.value)}
                                            onClear={() => setCountriesSelected([])}
                                            disabled={disabledCountries}
                                            multiple
                                        />
                                        <Select
                                            className="coursesManagementModalCreationSelect"
                                            label={t("header.roles")}
                                            options={roles}
                                            value={rolesSelected}
                                            placement="bottom-start"
                                            onChange={e => handleChangeRoles(e.value)}
                                            onClear={() => setRolesSelected([])}
                                            multiple
                                        />
                                        <br />
                                        <p><strong>{t("header.validity")+' *'}</strong></p>
                                        <br />
                                        <div className="coursesManagementModalCreationDate">
                                            <Checkbox
                                                className="coursesManagementModalCreationCheck"
                                                value={undefinedDates}
                                                onChange={handleChangeUndefinedDates}
                                                checked={undefinedDates}
                                                label={t("header.undefinedDates")} 
                                                aria-required/>

                                            {!undefinedDates &&
                                                <DatePicker
                                                    className="coursesManagementModalDatePicker"
                                                    blockPastDates
                                                    clearIcon={false}
                                                    endDate={endDate}
                                                    onChange={(date) => handleChangeDates(date as DateRange)}
                                                    orientation="horizontal"
                                                    range
                                                    startDatePlaceholder="mm/dd/yyyy"
                                                    endDatePlaceholder="mm/dd/yyyy"
                                                    format="LL"
                                                    startDate={startDate}
                                                    startDateLabel={t("header.stardDate")}
                                                    endDateLabel={t("header.endDate")}
                                                    maxDate={moment(startDate).add(12, "months")}
                                                    minimumNights={1}
                                                    required
                                                />}

                                        </div>

                                    </div>
                                )
                            }
                            else if (modalCreateId === 4) {
                                return (
                                    <div >
                                        {loadingMaterial ? <LoaderModal /> : null}

                                        <p><strong>{t("header.material")}</strong></p>
                                        <br />
                                        <TextBox
                                            className="coursesManagementModalCreationTextbox"
                                            label={t("header.title")}
                                            value={materialTitle}
                                            onChange={value => setMaterialTitle(value)}
                                            required
                                        />

                                        <TextArea
                                            className="coursesManagementModalCreationTextbox"
                                            label={t("header.description")}
                                            value={materialDescription}
                                            onChange={value => setMaterialDescription(value)}
                                            required
                                        />

                                        <FilePicker
                                            className="coursesManagementModalCreationFile"
                                            id="courseManagement-material-file-picker"
                                            label={t("header.uploadFile")}
                                            accept=".zip"
                                            onChange={handleFileChangeMaterial}
                                            onClear={onClearFilePickerMaterial}
                                            value={materialFileName}
                                            error={errorFilePickerMaterial}
                                            required
                                        />

                                    </div>
                                )
                            }
                            else if (modalCreateId === 5) {
                                return (
                                    <div className="coursesManagementModalCreationEvaluation">
                                        <p><strong>{t("header.evaluation")}</strong></p>
                                        <br />

                                        <div className="coursesManagementModalCreationEvaluationButtons">
                                            <Button className="coursesManagementModalCreationEvaluationButton" onClick={() => addQuestion(4)}>{t("header.singleAnswer")}</Button>
                                            <Button className="coursesManagementModalCreationEvaluationButton" onClick={() => addQuestion(1)}>{t("header.multipleAnswer")}</Button>
                                            <Button className="coursesManagementModalCreationEvaluationButton" onClick={() => addQuestion(2)}>{t("header.trueFalse")}</Button>
                                            <Button className="coursesManagementModalCreationEvaluationButton" onClick={() => addQuestion(3)}>{t("header.association")}</Button>
                                        </div>

                                        <div className="coursesManagementModalCreationEvaluationQuestions">

                                            {questions.map((question, indexQuestion) => {
                                                if (question.type === 1 || question.type === 4) {
                                                    return <Card
                                                        appearance="dropShadow"
                                                        className="coursesManagementModalCard"
                                                        content={<>
                                                            <div className='coursesManagementModalCardTop'>
                                                                <b>{indexQuestion + 1}</b>
                                                                <p>{question.type === 4 ? t("header.singleAnswer") : t("header.multipleAnswer")}</p>
                                                                <Button className="coursesManagementModalCardButtonDelete" appearance="secondary" colorScheme="negative" onClick={() => onDeleteQuestion(indexQuestion)} leadingIcon={<IconX />} />
                                                            </div>

                                                            <TextBox
                                                                className="coursesManagementModalTextbox"
                                                                label={t('header.question')}
                                                                id={'coursesManagementModal'}
                                                                value={question.question}
                                                                onChange={value => handleChangeQuestion(value, indexQuestion)}
                                                                required
                                                            />
                                                            <TextBox
                                                                className="coursesManagementModalTextbox"
                                                                label={t('header.hint')}
                                                                id={'coursesManagementModal'}
                                                                value={question.hint}
                                                                onChange={value => handleChangeHint(value, indexQuestion)}
                                                            />
                                                            <Select
                                                                className="coursesManagementModalSelects"
                                                                label={t("header.numberOptions")}
                                                                onChange={e => handleChangeNumberOptions(e.value, indexQuestion)}
                                                                onClear={() => onClearNumberOptions(indexQuestion)}
                                                                options={NumberOptions}
                                                                value={question.numberOptions}
                                                                placement="bottom-start"
                                                                required
                                                            />
                                                            {question.options && <span style={{ fontSize: 'small' }}>{t("header.selectCorrectOptions")}</span>}

                                                            {question.options?.map((option, indexOption) => {
                                                                if (question.type === 4) {
                                                                    return (
                                                                        <div className='coursesManagementModalSingle' key={"modalSingle-" + indexOption}>
                                                                            <RadioButton
                                                                                id={`radio-${indexOption}`}
                                                                                value={indexOption}
                                                                                checked={option.correct === true}
                                                                                onChange={(event) => handleChangeRadioButton(indexQuestion, event.target.value)}
                                                                            />
                                                                            <TextBox
                                                                                key={indexOption}
                                                                                className="coursesManagementModalTextboxOption"
                                                                                label={`${t('header.option')} ${indexOption + 1}`}
                                                                                id={'coursesManagementModalOption'}
                                                                                value={option.option}
                                                                                onChange={value => handleChangeOption(value, indexQuestion, indexOption)}
                                                                                required
                                                                            />

                                                                        </div>

                                                                    );
                                                                } else {
                                                                    return (
                                                                        <div className='coursesManagementModalSingle' key={indexOption}>
                                                                            <Checkbox id={"coursesManagementModalCheck-" + indexOption} value={option.correct} checked={option.correct} onChange={() => handleChangeChecks(indexQuestion, indexOption)} />
                                                                            <TextBox
                                                                                key={indexOption}
                                                                                className="coursesManagementModalTextboxOption"
                                                                                label={`${t('header.option')} ${indexOption + 1}`}
                                                                                id={'coursesManagementModalOption'}
                                                                                value={option.option}
                                                                                onChange={value => handleChangeOption(value, indexQuestion, indexOption)}
                                                                                required
                                                                            />

                                                                        </div>
                                                                    );
                                                                }
                                                            })}



                                                        </>}
                                                    />
                                                }
                                                else if (question.type == 2) {
                                                    return <Card
                                                        appearance="dropShadow"
                                                        className="coursesManagementModalCard"
                                                        content={<>
                                                            <div className='coursesManagementModalCardTop'>
                                                                <b>{indexQuestion + 1}</b>
                                                                <p>{t("header.trueFalse")}</p>
                                                                <Button className="coursesManagementModalCardButtonDelete" appearance="secondary" colorScheme="negative" onClick={() => onDeleteQuestion(indexQuestion)} leadingIcon={<IconX />} />
                                                            </div>

                                                            <TextBox
                                                                className="coursesManagementModalTextbox"
                                                                label={t('header.question')}
                                                                id={'coursesManagementModal'}
                                                                value={question.question}
                                                                onChange={value => handleChangeQuestion(value, indexQuestion)}
                                                                required

                                                            />
                                                            <br />
                                                            <div >
                                                                <RadioButtons name={`radioGroup-${indexQuestion}`} value={question.trueFalse} onChange={(event) => handleChangeRadioButtonTrueFalse(indexQuestion, event.target.value)} >
                                                                    <RadioButton id={"true"} value={"true"} label={t("header.true")} />
                                                                    <RadioButton id={"false"} value={"false"} label={t("header.false")} />
                                                                </RadioButtons>
                                                            </div>
                                                        </>}
                                                    />

                                                } else if (question.type == 3) {
                                                    return <Card
                                                        appearance="dropShadow"
                                                        className="coursesManagementModalCard"
                                                        content={<>
                                                            <div className='coursesManagementModalCardTop'>
                                                                <b>{indexQuestion + 1}</b>
                                                                <p>{t("header.association")}</p>
                                                                <Button className="coursesManagementModalCardButtonDelete" appearance="secondary" colorScheme="negative" onClick={() => onDeleteQuestion(indexQuestion)} leadingIcon={<IconX />} />
                                                            </div>

                                                            <TextBox
                                                                className="coursesManagementModalTextbox"
                                                                label={t('header.question')}
                                                                id={'coursesManagementModal'}
                                                                value={question.question}
                                                                onChange={value => handleChangeQuestion(value, indexQuestion)}
                                                                required
                                                            />
                                                            <Select
                                                                className="coursesManagementModalSelects"
                                                                label={t("header.numberOptions")}
                                                                onChange={e => handleChangeNumberOptionsAssociation(e.value, indexQuestion)}
                                                                onClear={() => onClearNumberOptionsAssociation(indexQuestion)}
                                                                options={NumberOptions}
                                                                value={question.numberOptions}
                                                                placement="bottom-start"
                                                            />

                                                            {question.associationQuestions?.map((option, indexOption) => {

                                                                return (
                                                                    <div className='coursesManagementModalAssociation' key={"modalAssociation-" + indexOption}>
                                                                        <TextBox
                                                                            key={"option" + indexOption}
                                                                            className="coursesManagementModalTextboxOption"
                                                                            label={`${t('header.option')} ${indexOption + 1}`}
                                                                            id={'coursesManagementModalOption'}
                                                                            value={option.option}
                                                                            onChange={value => handleChangeOptionAssociation(value, indexQuestion, indexOption, "option")}
                                                                            required
                                                                        />
                                                                        <TextBox
                                                                            key={"answer" + indexOption}
                                                                            className="coursesManagementModalTextboxOption"
                                                                            label={`${t('header.answer')} ${indexOption + 1}`}
                                                                            id={'coursesManagementModalOption'}
                                                                            value={option.answer}
                                                                            onChange={value => handleChangeOptionAssociation(value, indexQuestion, indexOption, "answer")}
                                                                            required
                                                                        />

                                                                    </div>

                                                                );

                                                            })}
                                                        </>}
                                                    />

                                                }

                                            })}



                                        </div>
                                    </div>
                                )
                            }
                            else if (modalCreateId === 6) {
                                return (
                                    <div className="coursesManagementModalCreationResume">
                                        <p><strong>{t("header.summary")}</strong></p>
                                        <br />
                                        <p><strong>{t("header.title") + ": "}</strong>{title}</p>
                                        <p><strong>{t("header.description") + ": "}</strong>{description}</p>
                                        <p><strong>{t("header.file") + ": "}</strong>{fileName}</p>
                                        <br />
                                        <p><strong>{t("header.clasification") + ": "}</strong>{clasifications.map((item: SelectOption) => {if(item.value === Number(clasificationSelected)){ return item.label + " "}})}</p>
                                        {categorySelected.length > 0 && <p><strong>{t("header.category") + ": "}</strong>{cateogories.map((item: SelectOption) => {if(item.value === Number(categorySelected)){ return item.label + " "}})}</p>}
                                        {subcategorySelected.length > 0 && <p><strong>{t("header.subcategory") + ": "}</strong>{subcategories.map((item: SelectOption) => {if(item.value === Number(subcategorySelected)){ return item.label + " "}})}</p>}
                                        <p><strong>{t("header.prerequisite") + ": "}</strong>{prerequisites.filter(item => String(prerequisitesSelected).split(',').map(val => val.trim()).includes(String(item.value))).map(item => item.label).join(', ')}</p>
                                        <br />
                                        <p><strong>{t("header.language") + ": "}</strong>{languages.map((item: SelectOption) => {if(item.value === Number(languageSelected)){ return item.label + " "}})}</p>
                                        <p><strong>{t("header.countries") + ": "}</strong>{countries.filter(item => String(countriesSelected).split(',').map(val => val.trim()).includes(String(item.value))).map(item => item.label).join(', ')}</p>
                                        <p><strong>{t("header.roles") + ": "}</strong>{roles.filter(item => String(rolesSelected).split(',').map(val => val.trim()).includes(String(item.value))).map(item => item.label).join(', ')}</p>
                                        <p><strong>{t("header.undefined") + ": "}</strong>{String(undefinedDates)}</p>
                                        {!undefinedDates && <p><strong>{t("header.stardDate") + ": "}</strong>{String(formatDateToYearMonthDay(startDate))}</p>}
                                        {!undefinedDates && <p><strong>{t("header.endDate") + ": "}</strong>{String(formatDateToYearMonthDay(endDate))}</p>}
                                        <br />
                                        <p><strong>{t("header.materialTitle") + ": "}</strong>{materialTitle}</p>
                                        <p><strong>{t("header.materialDescription") + ": "}</strong>{materialDescription}</p>
                                        <p><strong>{t("header.file") + ": "}</strong>{materialFileName}</p>
                                        <br />
                                        {questions.map((item, index) => {
                                            return (
                                                <ListItem key={'question' + index} leadingArea={<div >
                                                    <b>{item.question}</b>
                                                    <br />
                                                    <span style={{ fontSize: 'small' }}>{t("header.questionType") + ": " + getLabelQuestion(item.type)} </span>
                                                    {item.type === 2 && <p><strong>{t("header.answer") + ": "}</strong>{String(item.trueFalse)}</p>}
                                                    <div className="courseEditorModalResumeOptions">
                                                        {item.options?.map((option, indexOption: number) => {
                                                            if (item.type === 1) {
                                                                return <Checkbox disabled id="checkbox" label={option.option} checked={option.correct} />
                                                            } else if (item.type === 4) {
                                                                return <RadioButton disabled id="radio-id" label={option.option} checked={option.correct}/>
                                                            }
                                                        })}
                                                        {item.associationQuestions?.map((option, indexOption: number) => {
                                                            if (item.type === 3) {
                                                                return <p><strong>{t("header.option") + ": "}</strong>{option.option} {" - "} <strong>{t("header.answer") + ": "}</strong>{option.answer}</p>
                                                            }
                                                        })}
                                                    </div>
                                                </div>}
                                                />)
                                        })}

                                    </div>
                                )
                            }
                        })()}






                    </div>
                </Modal>
            </div>


        </>
    );
};

export default CourseManagementEditorModal;